import { render, staticRenderFns } from "./CalloutAlert.vue?vue&type=template&id=51c63b5c&scoped=true&"
import script from "./CalloutAlert.vue?vue&type=script&lang=js&"
export * from "./CalloutAlert.vue?vue&type=script&lang=js&"
import style0 from "./CalloutAlert.vue?vue&type=style&index=0&id=51c63b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c63b5c",
  null
  
)

export default component.exports